import { SessionFilterStorage } from './filter-session-storage';

export class QuickFilterSessionStorage extends SessionFilterStorage {
  /**
   * @private
   * @param {string} featureName - feature name
   * @return {string} - return storage key
   */
  getStorageKey(featureName) {
    return `WebApp.CampaignUI.${featureName}`;
  }

  /**
   * Get filter object, to keep compatible with permanent filter storage.
   * @return {Object} - Filter object that contains key and query
   */
  getFilterInSync() {
    return this.get();
  }
}
